<template>
  <div>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
        You have only view permission.
    </div>
    <div class="row" :disabled="!ifTeamleaderAnchorPermission">
      <div class="col-3 padding-l-n">
        <tl-select
          name="month"
          id="month"
          label="Month *"
          labelText="name"
          :options="monthsData"
          v-model="formData.monthObj"
          v-validate="'required'"
          :classname="errors.has('month')"
          :errormsg="errors.first('month')"
          @change="
            (val) => {
              formData.monthObj = val;
              resetForm();
            }
          "
        ></tl-select>
        </div>
    </div>
    <div class="row margin-t-m" :disabled="!ifTeamleaderAnchorPermission">
      <div class="col-3padding-l-n">
        <tl-select
          label="Paygroup"
          labelText="name"
          v-model="paygroup"
          :multiple="true"
          :options="paygroupOptions"
          @change="(val)=>paygroup = val"
        />
      </div>
      <div class="col-3">
        <tl-select
          label="Criteria"
          v-model="criteria"
          :options="criteriaOptions"
          @change="(val) => {criteria = val;onSelectCriteria(val)}"
        />
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <tl-select
          :label="subCriteriaLabel"
          labelText="name"
          v-model="subcriteria"
          :multiple="true"
          :options="subCriteriaList"
          @change="(val)=>subcriteria = val"
        />
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilter"></btn>
      </div>
    </div>
    <div class="row margin-t-m" :disabled="!ifTeamleaderAnchorPermission">
      <div class="col-12 padding-l-n">
        <span class="sm-text">Enter Employee Name/Code</span>
        <tl-search @change="filterData($event)" :placeholder="'Search Employee Name'" />
      </div>
    </div>

    <data-table
      class="margintop-20"
      :columns="columnNames"
      :tableData="lopData"
      :checkbox="false"
      :withForm="false"
      :showinrow="true"
      :showdelete="false"
      :showhistory="false"
      :showedit="false"
      @editStart="initEditStart"
      :disabled="!ifTeamleaderAnchorPermission"
    >
      <template v-slot:rowcontent="slotprops">
        <p
          v-if="slotprops.value.column.key == 'code'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <p
          v-if="slotprops.value.column.key == 'name'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <!-- cost-center key change - 21/11/2019 -->
        <p
          v-if="slotprops.value.column.key == 'ccName'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <p
          v-if="slotprops.value.column.key == 'reportingmgr'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <div v-if="slotprops.value.column.key == 'no_of_lop_days'">
          {{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key]:0}}
          <!-- <div
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{item}}</div>-->
        </div>
        <div v-if="slotprops.value.column.key == 'lop_days'">
          <div
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{item}}</div>
        </div>
        <div v-if="slotprops.value.column.key == 'no_of_rlop_days'">
          {{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key] :0}}
          <!-- <div
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{item}}</div>-->
        </div>
        <div v-if="slotprops.value.column.key == 'rlop_date'">
          <div
            v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]"
            :key="index"
          >{{item}}</div>
        </div>
      </template>
    </data-table>
  </div>
</template>


<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  components: {
    SearchDropdown
  },
  props: {
    employeeLopDataList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      paygroup: "",
      subcriteria: [],
      paygroupOptions: [],
      criteria: "",
      criteriaOptions: [
        "Band",
        "Cost Centre",
        "Business Unit",
        "Grade",
        "Location"
      ],
      subCriteriaList: [],
      subCriteriaLabel: "",
      empId: "",
      employeeData: [],
      monthsData: [
        
      ],
      month: "",
      yearEnd:"",
      year:"",
      monthsList: [
        { name: "January", value: "jan" },
        { name: "February", value: "feb" },
        { name: "March", value: "mar" },
        { name: "April", value: "apr" },
        { name: "May", value: "may" },
        { name: "June", value: "jun" },
        { name: "July", value: "jul" },
        { name: "August", value: "aug" },
        { name: "September", value: "sep" },
        { name: "October", value: "oct" },
        { name: "November", value: "nov" },
        { name: "December", value: "dec" }
      ],
      columnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Cost Centre",
          key: "ccName"
        },
        {
          label: "Reporting Mgr",
          key: "reporting_manager_name"
        },
        {
          label: "No. of LOP",
          key: "no_of_lop_days"
        },
        {
          label: "LOP Dates/Month",
          key: "lop_days"
        },
        {
          label: "No. of RLOP",
          key: "no_of_rlop_days"
        },
        {
          label: "RLOP Dates/Month",
          key: "rlop_date"
        }
      ],
      formData: {
        monthObj: "",
        yearsObj: "",
      },
      lopData: [],
      tableData: [],
      lopRlopValue: false,
      role: ""
    };
  },
  activated() {
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    this.lopData = this.employeeLopDataList;
    this.tableData = this.employeeLopDataList;
    this.getPaygroups();
    this.fetchAllEmployeesLOPRLOP();
    this.getOrgLeIdList();
    this.getFinancialYear();
  },
  mounted() {
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    this.getPaygroups();
    this.lopData = this.employeeLopDataList;
    this.tableData = this.employeeLopDataList;
    this.getOrgLeIdList();
    this.getFinancialYear();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapState({
      lopRlopData: state => state.dashboard.payroll.utilities.lopsandrlop,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.lopRlopValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
      act_create: "dashboard/payroll/utilities/uploadloprlop/create",
      act_fetch: "dashboard/payroll/utilities/uploadloprlop/fetchAll",
      act_fetchlop: "dashboard/payroll/utilities/uploadloprlop/fetchLOPsByEmp",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll"
    }),

    /* server call to get employee list with lop and rlop data */
    async fetchAllEmployeesLOPRLOP() {
      try {
        let res = await this.act_fetch({
          le_id: this.le_id,
          month: this.month.value,
          financial_year:
            new Date().getMonth() > 3
              ? new Date().getFullYear().toString()
              : (new Date().getFullYear() - 1).toString()
        });
        if (res.data.status) {
          this.lopData = res.data.payload;
          this.tableData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    getFinancialYear(){
      let month = this.payrollMonth;
      if(month == "January" ||month == "February" || month=="March"){
          this.yearEnd = Number(this.payrollYear);
          this.year = Number(this.payrollYear)-1;
      }else {
          this.yearEnd = Number(this.payrollYear) + 1;
          this.year = Number(this.payrollYear);
      }
      this.monthsData =[
        {name:`April-${this.year}`, val:"apr"},
        {name:`May-${this.year}`, val:"may"},
        {name:`June-${this.year}`, val:"jun"},
        {name:`July-${this.year}`, val:"jul"},
        {name:`August-${this.year}`, val:"aug"},
        {name:`September-${this.year}`, val:"sep"},
        {name:`October-${this.year}`, val:"oct"},
        {name:`November-${this.year}`, val:"nov"},
        {name:`December-${this.year}`, val:"dec"},
        {name:`January-${this.yearEnd}`, val:"jan"},
        {name:`February-${this.yearEnd}`, val:"feb"},
        {name:`March-${this.yearEnd}`, val:"mar"},
      ]
    },

    /* function to navigate to edit lop/rlop page */
    initEditStart(val) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/editEmployeeLop`,
        query: { id: val.id, code: val.code }
      });
    },

    /* server call to get employees after selecting filter options */
    async applyFilter() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formData.monthObj.val,
          financial_year: this.formData.monthObj.name.split("-")[1],
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Business Unit"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.act_fetch(obj);
        if (res.data.status) {
          this.lopData = res.data.payload;
          this.tableData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];
        this.tableData.forEach(element => {
          if (element.name || element.code) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1 || element.code.indexOf(val) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.lopData = tempArray;
        } else {
          this.lopData = this.tableData;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get subcriteria after changing criteria */
    onSelectCriteria(event) {
      try {
        this.subcriteria = [];
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Business Unit") {
          this.subCriteriaLabel = "Business Unit";
          this.getBU();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Locations */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary Bands */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Paygroups */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Business Units */
    async getBU() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get cost centre */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary grades */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to refresh the pages */
    refresh() {
      this.typeOfLeave = "";
      this.noofDays = "";
      this.dateOfLeave = "";
    },
    locklist(ee) {
      if (ee) {
        this.lockList = "Yes";
      } else {
        this.lockList = "No";
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.lopRlopValue = data.data.user.permissions.lop_rlop ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-filter {
  margin-top: 20px;
  padding: 0px;
  min-height: 35px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.sm-text {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
  margin-right: 32px;
  color: #444444;
  display: flex;
}
</style>
